import React from "react";

import styles from "./CustomButton.module.scss";

export const CustomButton = ({ text, icon, onClick, customStyle = {} }) => (
  <div onClick={onClick} className={styles.buttonContainer} style={customStyle}>
    {icon && icon()}
    <span className={styles.text}>{text}</span>
  </div>
);
